import { makeStyles } from '@material-ui/core/styles';

export const useFormTobaccoProductStyles = makeStyles(theme => ({
  formProduct: {
    flexGrow: 1
  }
}));
